export {}

const accordions = document.querySelectorAll<HTMLElement>('.i-accordion')
const currentUrl = new URL(window.location.href)

if (currentUrl.searchParams.has('group')) {
  const urlTargetId = currentUrl.searchParams.get('group')
  const targetAccordion = document.querySelector<HTMLElement>(`#${urlTargetId}`)

  if (targetAccordion) {
    if (!targetAccordion.classList.contains("--toggled")) targetAccordion.classList.add("--toggled")

    targetAccordion.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    })
  }

}

accordions.forEach((accordion) => {
  const accordionHeader = accordion.querySelector<HTMLElement>('.i-accordion__header')
  const accordionId = accordion.id

  accordionHeader?.addEventListener("click", () => {
    if (accordionId) {
      currentUrl.searchParams.set('group', `${accordionId}`)
    } else {
      if (currentUrl.searchParams.has('group')) currentUrl.searchParams.delete('group')
    }
    window.history.pushState({}, "", currentUrl.toString())
  })
})
